export default __webpack_public_path__ + "static/Make_In_India-19417b38424b9c8ad193671dbcbfedfd.png";